import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { IReasonApi } from "./base/reasonApi";
import { ReasonFilterRequest, ReasonRequest } from "../models/request";
import { Result } from "../models/common/resultResponse";

const baseRoute: string = "Reason";

export class ReasonApi extends IReasonApi {
	getDomain(request: ReasonFilterRequest): Promise<AxiosResponse<Result<ReasonRequest[]>>> {
		return api.get(`${baseRoute}/domain`, { params: request });
	}
}
